import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import { handleBooleanProp } from 'utils/commonUtils';
import { StickyTab, TabContainer } from 'components/Ui/styled';
import MyProfileInfo from '../components/myProfileInfo/MyProfileInfo';
import TabPanel, { a11yProps } from 'components/Common/TabPanel/TabPanel';
import MyPreferencesTab from '../components/myProfileInfo/MyPreferencesTab';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';
import UserExperienceTab from 'layouts/userLinks/components/userLinksTabs/userExperienceTab/UserExperienceTab';

const MyProfileTab = (props) => {
  const { profilePreferences, setProfilePreferences } = props;
  const [value, setValue] = useState(0);

  const canAccessUserPreferences = usePermissionCustomHook(
    'CAN_ACCESS_USER_PREFERENCES'
  );
  const canAccessTasks = usePermissionCustomHook('CAN_ACCESS_TASKS');

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: 'Profile',
      component: <MyProfileInfo />,
    },
    canAccessUserPreferences && {
      label: 'Preferences',
      component: (
        <MyPreferencesTab
          profilePreferences={profilePreferences}
          setProfilePreferences={setProfilePreferences}
        />
      ),
    },
    canAccessTasks && {
      label: 'Training Links',
      component: <UserExperienceTab />,
    },
  ].filter(Boolean);

  const singleTab = tabs?.length === 1;

  return (
    <TabContainer>
      <StickyTab
        value={value}
        onChange={handleTabChange}
        aria-label="myProfileTab"
        primary={handleBooleanProp(singleTab)}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />
        ))}
      </StickyTab>

      {tabs.map((tab, index) => (
        <TabPanel key={tab.label} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContainer>
  );
};

export default MyProfileTab;
